// extracted by mini-css-extract-plugin
module.exports = {"board":"eZxC883F","empty":"emd_6Jss"};